import {ActionContext} from "vuex";
import {ContentState} from "./content_module";
import {ContentProvider,} from "../../../../../domain/entities/content-provider/content-provider";
import {Content, ContentDoubt} from "../../../../presentation/views/content/helpers";

class ContentDoubtState {
  contentDoubts: ContentDoubt[] = [];
}

const state = new ContentDoubtState();
type DoubtActionContext = ActionContext<ContentDoubtState, ContentState>;

const mutations = {
  SET_CONTENT_DOUBTS(state: ContentDoubtState, contentDoubts: ContentDoubt[]) {
    state.contentDoubts = contentDoubts;
  },
  ADD_DOUBT(state: ContentDoubtState, contentDoubt: ContentDoubt) {
    state.contentDoubts?.unshift(contentDoubt);
  },
};

const getDependencies = ({rootGetters}: DoubtActionContext): { provider: ContentProvider, content: Content } => {
  const provider = rootGetters["content_module/contentProvider"];
  const content = rootGetters["content_module/currentContent"];

  if (!provider || !content) {
    throw new Error("ContentState is not ready");
  }

  return {provider, content};
}

const actions = {
  async loadDoubts(ctx: DoubtActionContext) {
    try {
      const {provider, content} = getDependencies(ctx);
      const contentDoubts = await provider.getAllDoubts(content.id) ?? [];
      ctx.commit("SET_CONTENT_DOUBTS", contentDoubts);
    } catch (e) {
      console.error("[loadRatings] Error getAllDoubts ", e);
      throw e;
    }
  },

  async createDoubt(ctx: DoubtActionContext, doubt: ContentDoubt) {
    try {
      const {provider, content} = getDependencies(ctx);
      const newDoubt = await provider.createDoubt(content.id, doubt);
      ctx.commit("ADD_DOUBT", newDoubt);
    } catch (e) {
      console.error("[createDoubt] Error createDoubt ", e);
      throw e;
    }
  },
};

const getters = {
  contentDoubts: (state: ContentDoubtState) => state.contentDoubts ?? [],
};

const modules = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
  modules,
};